/* eslint-disable @typescript-eslint/no-unsafe-return */
import * as sourceOfTruth from 'helpers/languages/en.json';
import en from 'helpers/languages/en.json';
import fr from 'helpers/languages/fr.json';
import { ReactNode } from 'react';
import { PrimitiveType, useIntl } from 'react-intl';

export type LocaleMessages = typeof sourceOfTruth;
export type LocaleKey = string;

export type SupportedLocales = 'en' | 'fr';

const BUNDLED_MESSAGES = { en, fr } as unknown as Record<SupportedLocales, LocaleMessages>;

const TRANSLATIO_URL = import.meta.env.VITE_TRANSLATIO_URL as string;

export const importMessages = (locale: SupportedLocales): Promise<LocaleMessages> => {
    const bundled = BUNDLED_MESSAGES[locale] ?? BUNDLED_MESSAGES.en;

    if (!TRANSLATIO_URL) {
        return Promise.resolve(bundled);
    }

    const url = `${TRANSLATIO_URL}/cdm-translations-${locale}.json`;

    return fetch(url)
        .then((response) => {
            if (!response.ok) {
                return bundled;
            }
            return response
                .json()
                .then((remote: Partial<LocaleMessages>) => ({ ...bundled, ...remote }))
                .catch(() => bundled);
        })
        .catch(() => bundled);
};

export const useTranslation = () => {
    const intl = useIntl();
    const translate: (id: LocaleKey, values?: Record<string, PrimitiveType | ReactNode>) => string | ReactNode = (
        id,
        values?,
    ) => {
        return intl.formatMessage({ id, defaultMessage: id }, values);
    };

    return translate;
};

export const useRawTranslation = () => {
    const intl = useIntl();
    const translate = (id: LocaleKey): string => {
        const message = intl.messages[id];
        return typeof message === 'string' ? message : id;
    };

    return translate;
};
